import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { computed } from '@ember/object';
import { modelApiAction } from 'cio/utils/model-api-actions';
import DS from 'ember-data';
import { inject as service } from '@ember/service';

export default class WebhookModel extends Model {
  @service store!: DS.Store;

  @attr('string', { defaultValue: '' }) name!: string;
  @attr('string') endpointUrl!: string;
  @attr('string') signingKey!: string;
  @attr('boolean', { defaultValue: false }) resolution!: boolean;
  @attr('array', { defaultValue: () => [] }) events!: string[] | null;
  @attr('boolean', { defaultValue: false }) enabled!: boolean;
  @attr('boolean', { defaultValue: false }) withContent!: boolean;

  @computed('events')
  get isForceDisabled() {
    return !this.events?.length;
  }

  regenerateSigningKey = modelApiAction({
    type: 'PUT',
    path: 'signing_key',
    after(this: WebhookModel, response) {
      this.store.pushPayload(response);
      return response;
    },
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    webhook: WebhookModel;
  }
}
